import PlanYourTripFormFullPage from "./PlanYourTripFormFullPage";

export const planYourTripFormFullPage = {
  init: () => {
    const form = document.querySelector(".pyt__content");
    if(form){
      new PlanYourTripFormFullPage(form);
    }
  },
};

export default planYourTripFormFullPage;
